export const isEORIUser = () => {
  return ['Ops', 'IT', '360PAY-STAFF'].includes(sessionStorage.getItem('department'));
};

export const isITUser = () => {
  return sessionStorage.getItem('department') === 'IT';
};

export const is360PayStaff = () => {
  return sessionStorage.getItem('department') === '360PAY-STAFF';
};
